import { InternalMessageType } from '../enums';
import { internalAddToCartResponsePayloadValidator } from '../messages';
import {
    InternalMessagePayloadByType,
    InternalMessagePayloadValidator,
} from '../types';

export const internalMessagePayloadValidators: Partial<{
    [MessageType in InternalMessageType]: InternalMessagePayloadValidator<MessageType>;
}> = {
    [InternalMessageType.AddToCartResponse]:
        internalAddToCartResponsePayloadValidator,
};

export const isInternalMessagePayload = <
    MessageType extends InternalMessageType,
>(
    type: MessageType,
    payload: unknown
): payload is InternalMessagePayloadByType[MessageType] => {
    const validator = internalMessagePayloadValidators[type];
    if (!validator) return false;
    return validator(payload);
};
